import React, { Component } from 'react';
import { connect } from 'react-redux';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import NotesList from './views/NotesList';
import NotePanel from './panels/NotePanel';
import ActionButton from '../components/ActionButton';
import PanelGroupController from '../components/PanelGroupController';
import PanelHeaderItem from '../components/PanelHeaderItem';
import { requestDeleteNote } from './NotesActions';
import { List, fromJS, Map } from 'immutable';
import FilterPanel from '../components/panels/FilterPanel';
import { allTags, 
  SHIPPING_ORDER_TYPE,
  SALES_ORDER_TYPE,
  SUBSCRIPTION_TYPE } from './notes';

const statusFilterOptions = fromJS([
  {id: "open", label: "Open"},
  {id: "resolved", label: "Resolved"}
])

const foreignTypeFilterOptions = fromJS([
  {id: "", label: "Any"},
  {id: SHIPPING_ORDER_TYPE, label: "Shipping Orders"},
  {id: SALES_ORDER_TYPE, label: "Sales Orders"},
  {id: SUBSCRIPTION_TYPE, label: "Subscriptions"}
])

const tagFilterOptions = allTags().map(tag => 
  Map({id: tag.get("id"), label: tag.get("name")})
).unshift(Map({id: "", label: "Any"}));

class NotesPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.handleDeleted = this.handleDeleted.bind(this);
    this.state = {
      noteId: "",
      hasSelection: false,
      statusFilter: "open",
      selectedPanelId: "filters",
      foreignTypeFilter: "",
      tagFilter: ""
    }
  }

  render() {
    let panels = this.renderPanels();

    return (
      <div className="NotesPage SecurePage">
        <AppSidebar />
        <PageHeader title="Notes & Annotations" />
        <div className="PageContainer">
          <NotesList
            selectedId={this.state.noteId}
            onSelectionChange={this.handleSetSelection}
            statusFilter={this.state.statusFilter}
            foreignTypeFilter={this.state.foreignTypeFilter}
            tagFilter={this.state.tagFilter}
            onDeleted={this.handleDeleted}
            />
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem show={true} label="Filters" id="filters" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={this.state.hasSelection} label="Details" id="details" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Delete Note"
              active={this.state.hasSelection}
              onClick={this.handleDeleteNote.bind(this)} />
          </PanelGroupController>
        </div>
      </div>
    );
  }

  handleDeleted(noteId) {
    if (this.state.noteId === noteId) {
      this.setState({noteId: "", hasSelection: false, selectedPanelId: "filters"});
    }
  }

  handleDeleteNote() {
    this.props.requestDeleteNote(this.state.noteId);
  }

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }

  renderPanels() {
    if (this.state.selectedPanelId === "filters") {
      return this.buildPanels(List(["statusFilter", "foreignTypeFilter", "tagFilter"]));
    } else {
      return this.buildPanels(List([NotePanel]));
    }
  }

  handleSetSelection(id) {
    this.setState({noteId: id, hasSelection: true, selectedPanelId: "details"});
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case NotePanel:
        return <NotePanel
                key="NotePanel"
                expanded={true}
                noteId={this.state.noteId}
                hasSelection={this.state.hasSelection}
                />

      case "statusFilter":
        return <FilterPanel
                key="StatusFilter"
                title="Status Filter"
                expanded={true}
                options={statusFilterOptions}
                onClick={this.handleSetStatusFilter.bind(this)}
                filter={this.state.statusFilter}
                />

      case "foreignTypeFilter":
        return <FilterPanel
                key="ForeignTypeFilter"
                title="Type Filter"
                expanded={true}
                options={foreignTypeFilterOptions}
                onClick={this.handleSetForeignTypeFilter.bind(this)}
                filter={this.state.foreignTypeFilter}
                />

      case "tagFilter":
        return <FilterPanel
                key="TagFilter"
                title="Tag Filter"
                expanded={true}
                options={tagFilterOptions}
                onClick={this.handleSetTagFilter.bind(this)}
                filter={this.state.tagFilter}
                />
      default:
        return null;      
    }
  }

  handleSetStatusFilter(item) {
    this.setState({
      statusFilter: item.get("id")
    });
  }     

  handleSetForeignTypeFilter(item) {
    this.setState({
      foreignTypeFilter: item.get("id")
    });
  }     

  handleSetTagFilter(item) {
    this.setState({
      tagFilter: item.get("id")
    });
  }     

}

export default connect(null, {requestDeleteNote})(NotesPage);